import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { DuoChatResponse } from 'generated/openapi';

import {
  type DuoChatKeyParams,
  getDuoChatKey,
  getDuoChatOptions,
} from './getDuoChat.options';

export interface UseGetDuoChatProps<
  T = DuoChatResponse,
> extends DuoChatKeyParams {
  options?: Omit<
    UseQueryOptions<DuoChatResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetDuoChat<T = DuoChatResponse>({
  options,
  ...params
}: UseGetDuoChatProps<T>) {
  return useQuery({
    ...getDuoChatOptions<T>(params),
    ...options,
  });
}

useGetDuoChat.getQueryKey = getDuoChatKey;
